import { useNuxtApp } from '#app'

export function getKeycloakToken() {
  const nuxtApp = useNuxtApp()
  const keycloak = nuxtApp.$keycloak
  return keycloak?.token ?? null
}

export async function getKeycloakTokenRaw() {
  const config = useRuntimeConfig()
  const keycloakUrl = config.public.keycloakUrl
  const realm = config.public.keycloakRealm
  const clientId = config.public.keycloakClientId
  const username = config.public.keycloakUsername
  const password = config.public.keycloakPassword

  if (!keycloakUrl || !realm || !clientId || !username || !password) {
    throw new Error(
      'Keycloak configuration (url, realm, client_id, username, or password) is not set in environment variables'
    )
  }

  // String body so Node fetch accepts the body under Vitest jsdom (URLSearchParams instanceof mismatch).
  const body = new URLSearchParams({
    client_id: clientId,
    grant_type: 'password',
    username,
    password,
  }).toString()

  const response = await fetch(
    `${keycloakUrl.replace(/\/$/, '')}/realms/${realm}/protocol/openid-connect/token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    }
  )

  if (!response.ok) {
    throw new Error(`Failed to fetch token: ${response.status}`)
  }

  const data = await response.json()
  return data.access_token
}
